module.exports = __webpack_public_path__ + "img/symbol_9.e5dbb321.png";